import { Outlet, useLocation } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";


const WithHeaderLayout = () => {
  const location = useLocation();
  const showFooter = ["/home", "/privacy", "/terms", "/data-deletion"].includes(location.pathname);
  return (
    <div>
      <Header/>
      <Outlet />
      {showFooter && <Footer />} 
    </div>
  );
};

export default WithHeaderLayout;
